import * as actionTypes from '../actions/ActionTypes';
import CacheMemory from '../helpers/CacheMemory';

export const RestoreState = (initialState) => {
    initialState['session'] = CacheMemory.get('session', true);
};

export default function setupReducer(rs) {
    rs[actionTypes.SET_SESSION] = (prevState, action) => {
        const session = action.payload;
        if (!session.access_token) return prevState;
        const expiresIn = Date.now() + (session.expires_in - 60) * 1000;
        CacheMemory.set('session', session, expiresIn);
        return {
            ...prevState,
            session,
        };
    };
    rs[actionTypes.CLEAR_SESSION] = (prevState, action) => {
        const session = null;
        return {
            ...prevState,
            session,
        };
    };
    rs[actionTypes.SET_SHOW_VACCOUNT_MODAL] = (prevState, action) => {
        const showVAccountModal = action.payload === true;
        return {
            ...prevState,
            showVAccountModal,
        };
    };
    rs[actionTypes.SET_VACCOUNT] = (prevState, action) => {
        const currentVirtualAccount = action.payload;
        const newSession = { ...prevState.session, currentVirtualAccount };
        const expiresIn = Date.now() + (newSession.expires_in - 60) * 1000;
        CacheMemory.set('session', newSession, expiresIn);
        return {
            ...prevState,
            session: newSession,
        };
    };
    rs[actionTypes.SET_TAGNAME_ID] = (prevState, action) => {
        return {
            ...prevState,
            tagsId: action.payload,
        };
    };
}
